import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import {
  canAccessProjectIntegrationSettings,
  canAccessProjectPlusButtonOptions,
  canAccessProjectSettings,
  canAccessProjectStyling,
} from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";

import { EditProjectPage } from "./pages/create-or-edit/EditProjectPage";
import { BringmePage } from "./pages/integrations/pages/BringmePage";
import { CopilotPage } from "./pages/integrations/pages/CopilotPage";
import { DicoPage } from "./pages/integrations/pages/DicoPage";
import { HealthDistrictPage } from "./pages/integrations/pages/HealthDistrictPage";
import { HomeDnaPage } from "./pages/integrations/pages/HomeDnaPage";
import { HubSpotPage } from "./pages/integrations/pages/HubSpotPage";
import { ILoqPage } from "./pages/integrations/pages/ILoqPage";
import { IntegrationsPage } from "./pages/integrations/pages/IntegrationsPage";
import { IqbiPage } from "./pages/integrations/pages/IqbiPage";
import { JansenHuybregtsPage } from "./pages/integrations/pages/JansenHuybregtsPage";
import { JimPage } from "./pages/integrations/pages/JimPage";
import { MyPupPage } from "./pages/integrations/pages/MyPupPage";
import { OfficeRndPage } from "./pages/integrations/pages/OfficeRndPage";
import { OutlookPage } from "./pages/integrations/pages/OutlookPage";
import { RemsPage } from "./pages/integrations/pages/RemsPage";
import { RemsReconciliationPage } from "./pages/integrations/pages/RemsReconciliationPage";
import { SwoogoPage } from "./pages/integrations/pages/SwoogoPage";
import { WunderbricksPage } from "./pages/integrations/pages/WunderbricksPage";
import { ZiezodanPage } from "./pages/integrations/pages/ZiezodanPage";
import { PlusButtonOptionsPage } from "./pages/plus-button-options/PlusButtonOptionsPage";
import { ProjectStylingPage } from "./pages/styling/ProjectStylingPage";
import { projectRoutes } from "./routes";

export const projectsRoute = [
  {
    path: projectRoutes.edit,
    element: (
      <RequireAuth permission={canAccessProjectSettings}>
        <EditProjectPage />
      </RequireAuth>
    ),
  },
  {
    path: projectRoutes.styling,
    element: (
      <RequireAuth permission={canAccessProjectStyling}>
        <ProjectStylingPage />
      </RequireAuth>
    ),
  },
  {
    path: projectRoutes.plusButtonOptions,
    element: (
      <RequireAuth permission={canAccessProjectPlusButtonOptions}>
        <PlusButtonOptionsPage />
      </RequireAuth>
    ),
  },
  {
    path: projectRoutes.integrations,
    element: (
      <RequireAuth permission={canAccessProjectIntegrationSettings}>
        <IntegrationsPage />
      </RequireAuth>
    ),
  },
  {
    path: projectRoutes.integrationZiezodan,
    element: (
      <RequireAuth permission={canAccessProjectIntegrationSettings}>
        <ZiezodanPage />
      </RequireAuth>
    ),
  },
  {
    path: projectRoutes.integrationRems,
    element: (
      <RequireAuth permission={canAccessProjectIntegrationSettings}>
        <RemsPage />
      </RequireAuth>
    ),
  },
  {
    path: projectRoutes.integrationRemsAddresses,
    element: (
      <RequireAuth permission={canAccessProjectIntegrationSettings}>
        <RemsReconciliationPage dataType="addresses" />
      </RequireAuth>
    ),
  },
  {
    path: projectRoutes.integrationRemsResidents,
    element: (
      <RequireAuth permission={canAccessProjectIntegrationSettings}>
        <RemsReconciliationPage dataType="residents" />
      </RequireAuth>
    ),
  },
  {
    path: projectRoutes.integrationHomeDna,
    element: (
      <RequireAuth permission={canAccessProjectIntegrationSettings}>
        <HomeDnaPage />
      </RequireAuth>
    ),
  },
  {
    path: projectRoutes.integrationDico,
    element: (
      <RequireAuth permission={canAccessProjectIntegrationSettings}>
        <DicoPage />
      </RequireAuth>
    ),
  },
  {
    path: projectRoutes.integrationOutlook,
    element: (
      <RequireAuth permission={canAccessProjectIntegrationSettings}>
        <OutlookPage />
      </RequireAuth>
    ),
  },
  {
    path: projectRoutes.integrationJim,
    element: (
      <RequireAuth permission={canAccessProjectIntegrationSettings}>
        <JimPage />
      </RequireAuth>
    ),
  },
  {
    path: projectRoutes.integrationIqbi,
    element: (
      <RequireAuth permission={canAccessProjectIntegrationSettings}>
        <IqbiPage />
      </RequireAuth>
    ),
  },
  {
    path: projectRoutes.integrationMyPup,
    element: (
      <RequireAuth permission={canAccessProjectIntegrationSettings}>
        <MyPupPage />
      </RequireAuth>
    ),
  },
  {
    path: projectRoutes.integrationBringme,
    element: (
      <RequireAuth permission={canAccessProjectIntegrationSettings}>
        <BringmePage />
      </RequireAuth>
    ),
  },
  {
    path: projectRoutes.integrationCopilot,
    element: (
      <RequireAuth permission={canAccessProjectIntegrationSettings}>
        <CopilotPage />
      </RequireAuth>
    ),
  },
  {
    path: projectRoutes.integrationSwoogo,
    element: (
      <RequireAuth permission={canAccessProjectIntegrationSettings}>
        <SwoogoPage />
      </RequireAuth>
    ),
  },
  {
    path: projectRoutes.integrationOfficeRnd,
    element: (
      <RequireAuth permission={canAccessProjectIntegrationSettings}>
        <OfficeRndPage />
      </RequireAuth>
    ),
  },
  {
    path: projectRoutes.integrationHubSpot,
    element: (
      <RequireAuth permission={canAccessProjectIntegrationSettings}>
        <HubSpotPage />
      </RequireAuth>
    ),
  },
  {
    path: projectRoutes.integrationHealthDistrict,
    element: (
      <RequireAuth permission={canAccessProjectIntegrationSettings}>
        <HealthDistrictPage />
      </RequireAuth>
    ),
  },
  {
    path: projectRoutes.integrationWunderbricks,
    element: (
      <RequireAuth permission={canAccessProjectIntegrationSettings}>
        <WunderbricksPage />
      </RequireAuth>
    ),
  },
  {
    path: projectRoutes.integrationILoq,
    element: (
      <RequireAuth permission={canAccessProjectIntegrationSettings}>
        <ILoqPage />
      </RequireAuth>
    ),
  },
  {
    path: projectRoutes.integrationJansenHuybregts,
    element: (
      <RequireAuth permission={canAccessProjectIntegrationSettings}>
        <JansenHuybregtsPage />
      </RequireAuth>
    ),
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
